import bem from 'utils/bem';

export const block = bem('exit-retry-period-modal');
